<template>
  <div class="filter-group filter-group--discount">
    <h3 class="filter-group__title filter-group__title--discount">{{ this.$i18n.discountTitle }}</h3>
    <label class="field-wrap">
      <div class="checkbox">
        <input id="discounts" v-model="activeDiscount" type="checkbox" />
        <div class="checkbox__box"></div>
      </div>
      <span>{{ this.$i18n.hasDiscount }}</span>
    </label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeDiscount: false
    };
  },
  watch: {
    activeDiscount(value) {

      let query = Object.assign({}, this.$route.query);

      query.onsale = value ? 1 : 0;

      this.$router
        .push({
          name: "Catalog",
          query,
        })
        .catch((err) => { });

    }
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/filter/Discounts.vue